import { type DayCounter } from "../api/useGetFacilityShiftCounts";

/**
 * Merges two shift type counter objects by adding their counts together.
 */
function mergeShiftTypeCounts(
  a: DayCounter["filledShifts"],
  b: DayCounter["filledShifts"]
): DayCounter["filledShifts"] {
  if (!a && !b) {
    return undefined;
  }

  return {
    am: (a?.am ?? 0) + (b?.am ?? 0),
    pm: (a?.pm ?? 0) + (b?.pm ?? 0),
    noc: (a?.noc ?? 0) + (b?.noc ?? 0),
    custom: (a?.custom ?? 0) + (b?.custom ?? 0),
    ori: (a?.ori ?? 0) + (b?.ori ?? 0),
  };
}

/**
 * Merges two DayCounter objects by adding their counts together.
 * Used when combining results from multiple qualification queries.
 */
export function mergeDayCounts(a: DayCounter, b: DayCounter): DayCounter {
  return {
    cancelled: (a.cancelled ?? 0) + (b.cancelled ?? 0),
    filledCount: (a.filledCount ?? 0) + (b.filledCount ?? 0),
    openCount: (a.openCount ?? 0) + (b.openCount ?? 0),
    total: (a.total ?? 0) + (b.total ?? 0),
    instantFillOpenCount: (a.instantFillOpenCount ?? 0) + (b.instantFillOpenCount ?? 0),
    filledShifts: mergeShiftTypeCounts(a.filledShifts, b.filledShifts),
    openShifts: mergeShiftTypeCounts(a.openShifts, b.openShifts),
    instantFillOpenShifts: mergeShiftTypeCounts(a.instantFillOpenShifts, b.instantFillOpenShifts),
  };
}
